<template>
  <div class="ly-card news-content-edit">
    <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm">
      <template v-slot:content_url="{ formData }">
        <div class="media-content">
          <div v-if="formData.content_url" class="media-item">
            <img :src="`${baseUrl}/${formData.content_url}`" width="200px" />
            <i class="el-icon-close" @click="removeMedia"></i>
          </div>
        </div>
        <upload
          v-show="!formData.content_url"
          ButtonText="上传附件"
          :action="action"
          tips="尺寸比例 16*9"
          @successCBK="value => attachChange(value, formData)"
          :accept="picAcc"
        />
      </template>
      <template v-slot:content="{ formData }">
        <tinymce ref="tinymce" v-model="formData.content" :height="400" />
      </template>
    </ly-form>
    <div class="buttom">
      <el-button @click.native="back">返 回</el-button>
      <el-button @click.native="addSubmit" type="primary">保 存</el-button>
    </div>
  </div>
</template>
<script>
import cUser from '@/api/cUser';
import cNews from '@/api/cNews';
import LyForm from '@/components/LyForm';
import { newsFormItem } from '@/utils/communityFormConfig';
import Upload from '@/components/cUpload';
import Tinymce from '@/components/Tinymce';
import localCache from '@/utils/localCache';

export default {
  name: 'newsContentDetail',
  components: {
    Upload,
    LyForm,
    Tinymce
  },
  data() {
    return {
      defaultFormItem: {},
      formKeys: newsFormItem,
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        inline: false
      },
      action: cUser.cUpload,
      picAcc: '.jpg, .jpeg, .png, .gif, .bmp',
      baseUrl: '',
      formData: {}
    };
  },
  computed: {
    news_content_id() {
      if (!this.$route.params.id) return -1;
      return parseInt(this.$route.params.id, 10);
    },
    isAdd() {
      return this.news_content_id === -1;
    }
  },
  mounted() {
    this.init();
  },
  activated() {
    this.init();
  },
  methods: {
    async init() {
      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
      if (this.isAdd) {
        this.reset();
      } else {
        this.defaultFormItem = localCache.getItem('newsContentInfo');
        this.formData = this.defaultFormItem;
      }
    },
    async addSubmit() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (!valid) return;
      let res = null;
      if (this.isAdd) {
        res = await cNews.addNewsContent({
          params: data
        });
      } else {
        const date = new Date();
        // eslint-disable-next-line max-len
        const updateTime = `${date.getFullYear()}-${this.fillZero(date.getMonth() + 1)}-${this.fillZero(date.getDate())} ${this.fillZero(date.getHours())}:${this.fillZero(date.getMinutes())}:${this.fillZero(date.getSeconds())}`;
        res = await cNews.updateNewsContent({
          params: { ...data, update_time: updateTime },
          news_content_id: this.news_content_id,
          methold: 'PUT'
        });
      }
      if (res) {
        this.$message.success(res.msg || '发布成功！');
        this.back();
      }
    },
    reset() {
      this.$refs.tinymce.setContent('');
      this.defaultFormItem = {};
      if (this.$refs.lyFormBriefed) this.$refs.lyFormBriefed.resetFields();
    },
    back() {
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.replace({ path: `/${this.$route.params.user_id}/community/newsContent` });
      });
    },
    attachChange(value, formData) {
      // eslint-disable-next-line no-param-reassign
      formData.content_url = value[0].url;
      this.formData = formData;
    },
    removeMedia() {
      this.$refs.lyForm.setFormData('content_url', '');
      this.formData.content_url = '';
    },
    fillZero(str) {
      let realNum;
      if (str < 10) {
        realNum = `0${str}`;
      } else {
        realNum = str;
      }
      return realNum;
    }
  }
};
</script>
<style lang="less">
.news-content-edit{
  .ly-form .el-input__inner {
    width: 220px;
  }
  .content-width-full {
    .el-form-item {
      width: 100%;
      .el-form-item__content {
        width: 100%;
      }
    }
  }
  .el-textarea__inner {
    width: 600px;
  }
  .media-content {
    display: flex;
  }
  .media-item {
    position: relative;
    font-size: 26px;
    color: @danger;
    > .el-icon-close {
      display: block;
      position: absolute;
      top: -9px;
      right: -8px;
      background: #f3f3f3;
      cursor: pointer;
      font-size: 18px;
    }
  }
}
</style>
